import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  snackbar,
  ConfirmDialog,
  Typography,
  TableRowActionsMenu,
  useConfirmDialog,
} from '@occc-app/design-system';
import { useOfferDeleteMutation } from '@occc-app/dataAccessLayer/offer/mutations';

import { programManagementGameRouteCreator } from '../utils';

interface GameActionsContainerProps {
  id: string;
  name: string;
  deleted: boolean;
}

export const GameActionsContainer = ({ id, name, deleted }: GameActionsContainerProps) => {
  const navigate = useNavigate();

  const onDeleteComplete = () => {
    snackbar.success('Vouchered Game has been successfully archived.');
  };

  const [offerDelete] = useOfferDeleteMutation({
    onCompleted: onDeleteComplete,
    refetchQueries: ['offers'],
  });

  const onDelete = () =>
    offerDelete({
      variables: { id },
    });

  const { open, setOpen, onCloseButtonClick, onConfirmButtonClick } = useConfirmDialog({
    onConfirm: onDelete,
    shouldStopEventPropagation: true,
  });

  const menuItems = useMemo(() => {
    const items = [];

    items.push({
      label: 'Edit Vouchered Game',
      onClick: () => navigate(programManagementGameRouteCreator.updateWithTab(id)),
      dataTestId: 'edit',
    });

    if (!deleted) {
      items.push({
        label: 'Archive Vouchered Game',
        onClick: () => setOpen(true),
        dataTestId: 'archive',
      });
    }

    return items;
  }, [deleted, navigate, id, setOpen]);

  return (
    <>
      <TableRowActionsMenu menuItems={menuItems} />
      <ConfirmDialog
        dialogTitle='Are you sure?'
        open={open}
        onClose={onCloseButtonClick}
        confirmButtonText='Confirm'
        confirmButtonProps={{
          onClick: onConfirmButtonClick,
          color: 'error',
        }}
      >
        <Typography>This action will archive the "{name}".</Typography>
      </ConfirmDialog>
    </>
  );
};
